module.exports = __webpack_public_path__ + "static/icons/icon-update-4fce832c0565434bb783f35802ca915b.svg";